"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedTableCell = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
exports.WrappedTableCell = (0, styled_components_1.default)(core_1.TableCell) `
  white-space: normal;
  word-wrap: break-word;
  text-overflow: ellipsis;
`;
exports.default = exports.WrappedTableCell;
//# sourceMappingURL=WrappedTableCell.js.map